import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useCanManageTeam } from '@/hooks/useCanManageTeam';

interface AuthGateProps {
  children: React.ReactNode;
  requireOwner?: boolean;
  requireStaff?: boolean;
  // Owner de una organización Productora/Estudio (o staff de Pelip). Para /equipo.
  requireTeamManager?: boolean;
}

export default function AuthGate({ children, requireOwner = false, requireStaff = false, requireTeamManager = false }: AuthGateProps) {
  const { loading, isAuthenticated, isOwner, isStaff } = useAuth();
  const { data: canManageTeam, isLoading: loadingTeam } = useCanManageTeam(requireTeamManager);
  const location = useLocation();

  if (loading || (requireTeamManager && isAuthenticated && loadingTeam)) {
    return (
      <div className="min-h-screen bg-pelip-bg flex items-center justify-center">
        <p className="text-pelip-text-faint text-sm">Cargando…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (
    (requireOwner && !isOwner) ||
    (requireStaff && !isStaff) ||
    (requireTeamManager && !canManageTeam)
  ) {
    return (
      <div className="min-h-screen bg-pelip-bg flex items-center justify-center p-6">
        <div className="max-w-sm text-center">
          <h2 className="text-lg font-semibold text-pelip-text mb-2">Acceso restringido</h2>
          <p className="text-sm text-pelip-text-muted">Esta sección solo es accesible para administradores.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
